import script from "./AiCheckStats.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckStats.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckStats.vue?vue&type=style&index=0&id=71a17b36&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a17b36"]])

export default __exports__